/* eslint-disable no-param-reassign */
import { transformObjectValuesToUpperCase } from '@/transformer/transform';

export const transformAddress = address => {
    if (address.addressDetails) {
        // eslint-disable-next-line no-param-reassign
        address.addressDetails.address = address.addressDetails.address.toUpperCase();
        // eslint-disable-next-line no-param-reassign
        address.addressDetails.country = address.addressDetails.country.toUpperCase();
    }

    return address;
};

/* eslint-disable import/prefer-default-export */
export const transformCompanyDataForBackend = payload => {
    payload.payload.payload.companyData.businessCountries = payload.payload.payload.companyData.businessCountries.toUpperCase();
    payload.payload.payload.companyData.companyDomainText = payload.payload.payload.companyData.companyDomainText.toUpperCase();
    payload.payload.payload.companyData.companyName = payload.payload.payload.companyData.companyName.toUpperCase();
    payload.payload.payload.companyData.otherReasonToIncorporate = payload.payload.payload.companyData.otherReasonToIncorporate.toUpperCase();
    payload.payload.payload.companyData.otherSourceOfFund = payload.payload.payload.companyData.otherSourceOfFund.toUpperCase();
    payload.payload.payload.companyData.registeredAddress = transformAddress(payload.payload.payload.companyData.registeredAddress);
    payload.payload.payload.companyData.selectedDirectors = payload.payload.payload.companyData.selectedDirectors.map(director => transformObjectValuesToUpperCase(director));
    payload.payload.payload.companyData.selectedShareHolders = payload.payload.payload.companyData.selectedShareHolders.map(shareholder => transformObjectValuesToUpperCase(shareholder));

    return payload;
};
